export const InfoIcon = () => {
  return (
    <svg
      style={{ width: '30px', marginTop: '4px' }}
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
    >
      <path
        id='info-circle-light'
        d='M18,9.29A8.71,8.71,0,1,1,9.29,18,8.711,8.711,0,0,1,18,9.29M18,8A10,10,0,1,0,28,18,10,10,0,0,0,18,8ZM16.548,21.871h.484V17.032h-.484a.484.484,0,0,1-.484-.484v-.323a.484.484,0,0,1,.484-.484h1.935a.484.484,0,0,1,.484.484v5.645h.484a.484.484,0,0,1,.484.484v.323a.484.484,0,0,1-.484.484h-2.9a.484.484,0,0,1-.484-.484v-.323A.484.484,0,0,1,16.548,21.871ZM18,12.194a1.29,1.29,0,1,0,1.29,1.29A1.29,1.29,0,0,0,18,12.194Z'
        transform='translate(-8 -8)'
        fill='#122455'
      />
    </svg>
  );
};
